export const CONSENT_CATEGORIES = {
    NECESSARY: 'necessary',
    FUNCTIONAL: 'functional',
    ANALYTICS: 'analytics',
    MARKETING: 'marketing'
};

export const CONSENT_CATEGORY_LIST = [
    CONSENT_CATEGORIES.NECESSARY,
    CONSENT_CATEGORIES.FUNCTIONAL,
    CONSENT_CATEGORIES.ANALYTICS,
    CONSENT_CATEGORIES.MARKETING
];

export function createDefaultConsentState() {
    return {
        necessary: true,
        functional: false,
        analytics: false,
        marketing: false,
        ready: false,
        source: 'default'
    };
}